import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@paypalcorp/pp-react-radio';
import { Badge } from '@paypalcorp/pp-react-badge';
import { css, StyleSheet } from 'aphrodite';
import { shouldShowBadge } from '../../utilsV3/badgeUtils';

const styles = StyleSheet.create({
  customMargin: {
    marginTop: '4px',
    '@media (max-width: 576px)': {
      marginTop: '12px',
      ':nth-child(1n) > label': {
        display: 'inline-flex',
      },
    },
  },
});

class BasicRadioField extends Component {
  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    labelClassName: PropTypes.string,
    meta: PropTypes.object,
    id: PropTypes.string,
    dataTestId: PropTypes.string,
    checkedValue: PropTypes.string,
    tooltipContent: PropTypes.string,
    tooltipId: PropTypes.string,
    customTooltipClass: PropTypes.string,
    className: PropTypes.string,
    helperText: PropTypes.string,
    topLabel: PropTypes.bool,
    showBadge: PropTypes.bool,
  };

  render() {
    const { input, label, id, dataTestId, className, showBadge } = this.props;
    const badgeContent = shouldShowBadge(showBadge);

    return (
      <Radio
        label={label}
        labelIcon={
          badgeContent && (
            <Badge aria-hidden={true} type="feature" className="badge-feature">
              {badgeContent}
            </Badge>
          )
        }
        labelClassName={this.props.labelClassName || ''}
        className={`${className} ${
          this.props.tooltipContent && `${css(styles.customMargin)}`
        }`}
        id={id}
        data-testid={dataTestId}
        checked={this.props.checkedValue === input.value}
        centeredLabel={this.props.topLabel ? false : true}
        helperText={this.props.helperText ?? ''}
        {...input}
      />
    );
  }
}
export default BasicRadioField;
